import React from 'react';
import { Image, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../../images/logo.png';
import styles from './Header.module.css';

const Header = () => {
  const navItem = {
    padding: '8px'
  }
  return (
    <Navbar expand="lg" className={styles.headerbg}>
      <Navbar.Toggle aria-controls="navbarScroll" className="m-3" />
      <Navbar.Collapse id="navbarScroll" className={styles.flexitems}>
        <Link to="/"><Image src={logo} width='200px' fluid /></Link>
        <Nav
          className={`mr-auto my-2 my-lg-0 d-flex ${styles.navbarCss}`}
          navbarScroll
        >
          <Link style={navItem} to="/" className="mx-2">Home</Link>
          <Link style={navItem} to="/impact" className="mx-2">Impact</Link>
          <Link style={navItem} to="/resource" className="mx-2">Resource</Link>
          <Link style={navItem} to="/team" className="mx-2">Team</Link>
          <Link style={navItem} to="/collaboration" className="mx-2">Collaboration</Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;